import Api from "./Api";

const ENDPOINT = "/public";

export const getStats = async () => {
    const response = await Api.get(`${ENDPOINT}/stats`);
    return response.data;
};

export const getPopularCategories = async () => {
    const response = await Api.get(`/joboffer/popular-categories`);
    // console.log(response)
    return response.data;
};

export const getFeaturedJobs = async () => {
    const response = await Api.get(`${ENDPOINT}/featured-jobs`);
    return response.data;
};

export const getTopCompanies = async () => {
    const response = await Api.get(`${ENDPOINT}/top-companies`);
    return response.data;
};
